<form #custoAdicionalForm="ngForm">
    <app-custom-modal #modal [title]="'Custo adicional'"
        [subtitle]="'A criação de novos pacientes só ficará disponível após o pagamento se confirmado!'" [hideCancel]="custo.status"
        (onCloseClick)="modal.close()" (onSaveClick)="save()" [saveLabel]="'Realizar Pagamento →'" [hideSave]="custo.status"
        [saveDisabled]="custoAdicionalForm.invalid && saving">
        <div class="container">
            <div class="table-container table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Valor</th>
                            <th>Data de início</th>
                            <th>Data final</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{custo.valor | currency:'BRL':'symbol'}}</td>
                            <td>{{custo.dataInicio | date: 'dd/MM/yyyy'}}</td>
                            <td>{{custo.dataFim | date: 'dd/MM/yyyy'}}</td>
                            <td>{{getStatus()}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <metodos-pagamentos *ngIf="!custo.status" #metodosPagamento [valor]="custo.valor" />

            <div class="row" *ngIf="custo?.qrCodeBase64">
                <div class="col-md-12">{{ "MensagemPixUm" | localize }}</div>
                <div class="col-md-12">{{ "MensagemPixDois" | localize }}</div>
                <div class="col-md-12">{{ "MensagemPixTres" | localize }}</div>

                <div class="col-md-12 text-center mt-3">
                    <img style="width: 150px" [src]="'data:image/jpeg;base64,' + custo?.qrCodeBase64">
                </div>

                <div class="col-md-12 text-center mt-3">
                    {{ custo?.qrCode }}
                </div>
            </div>


            <div class="row" *ngIf="custo?.boletoUrl">
                <div class="col-md-12">{{ "MensagemBoletoUm" | localize }}</div>

                <div class="col-md-12 text-center mt-3">
                    <a [href]="custo?.boletoUrl" class="btn btn-outline-primary" target="_blank">
                        <i class="fa fa-link"></i>
                        {{ "VisualizarBoleto" | localize }}
                    </a>
                </div>
            </div>
        </div>
    </app-custom-modal>
</form>